var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.certStatus)?_c('span',[_c('i',{class:_vm.statusList[_vm.certStatus].icon}),_vm._v(" "+_vm._s(_vm.statusList[_vm.certStatus].description)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }